import {
  Box,
  Collapse,
  IconButton,
  Link,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material'
import { ReactNode } from 'react'
import { LinkIcon } from 'src/assets/icons'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { ChevronDownIcon } from 'src/assets/icons/v2/ChevronDownIcon'
import { ChevronUpIcon } from 'src/assets/icons/v2/ChevronUpIcon'
import { getPolygonscanAddressUrl, shortenStringMiddle } from 'src/common/utils'
import { useCopy, useToggle } from 'src/hooks'
import { IUserWalletBase } from 'src/types'

import { useStyles } from './../styles'

interface IProps {
  children: ReactNode
  wallet: Omit<IUserWalletBase, 'privateKey'>
}

export const WalletDetailsItem = ({ children, wallet }: IProps) => {
  const [toggle, handleCollapse] = useToggle()
  const theme = useTheme()
  const classes = useStyles()

  const handleCopy = useCopy(wallet.address)

  return (
    <>
      <ListItemButton
        onClick={() => handleCollapse()}
        disableGutters
        sx={{ borderRadius: '10px', px: '10px' }}
      >
        <ListItemIcon>
          {toggle ? (
            <ChevronUpIcon size={28} color={theme.palette.custom.darkBlue2} />
          ) : (
            <ChevronDownIcon size={28} color={theme.palette.custom.darkBlue2} />
          )}
        </ListItemIcon>
        <ListItemText disableTypography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '3px',
              justifyContent: 'space-between',
            }}
          >
            <Typography sx={{ fontSize: '14px' }}>{shortenStringMiddle(wallet.address)}</Typography>

            <Box sx={{ display: 'flex', gap: '3px' }}>
              <IconButton
                disabled={!wallet.address}
                size="small"
                component={Link}
                href={wallet.address ? getPolygonscanAddressUrl(wallet.address) : '#'}
                target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                <LinkIcon className={classes.copyIcon} />
              </IconButton>

              <IconButton
                size="small"
                disabled={!wallet.address}
                onClick={(e) => {
                  e.stopPropagation()
                  handleCopy()
                }}
              >
                <ContentCopyIcon className={classes.copyIcon} />
              </IconButton>
            </Box>
          </Box>
        </ListItemText>

        {/* <IconButton
          sx={{ ml: 'auto', p: 1 }}
          onClick={(e) => {
            e.stopPropagation()
            deleteHandler(index)
          }}
        >
          <DeleteIcon className={classes.deleteIcon} />
        </IconButton> */}
      </ListItemButton>
      <Collapse in={toggle} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  )
}
